module.exports = require('./dist/environment/environment.js');
